if (!customElements.get('lazy-video')) {
	class LazyVideo extends HTMLElement {
		connectedCallback() {
			const videos = this.querySelectorAll('video[data-src]');
			videos.forEach((video) => {
				if (video.hasAttribute('data-breakpoint-mobile') && matchMedia('screen and (max-width: 769px)')?.matches) {
					video.src = video.getAttribute('data-src');
				} else if (
					video.hasAttribute('data-breakpoint-desktop') &&
					!matchMedia('screen and (max-width: 769px)')?.matches
				) {
					video.src = video.getAttribute('data-src');
				} else {
					video.classList.add('hide');
				}
			});
		}
	}
	customElements.define('lazy-video', LazyVideo);
}
if (!customElements.get('scroll-slider')) {
	// this only handles changing dots style
	class scrollSlider extends HTMLElement {
		connectedCallback() {
			this.dots = document.querySelector(`[aria-controls="${this.getAttribute('id')}"]`);
			// theme.utils.throttle(20, stickyHeaderScroll)
			this.addEventListener('scroll', theme.utils.throttle(50, this.handleScroll));
		}
		handleScroll = () => {
			const selectedIndex = Math.round(this.scrollLeft / this.clientWidth);
			this.changeDot(selectedIndex);
		};
		changeDot(selectedIndex) {
			if (!this.dots) return;
			Array.from(this.dots.children).forEach((dot, index) => {
				if (index === selectedIndex) {
					dot.setAttribute('aria-current', 'true');
				} else {
					dot.setAttribute('aria-current', 'false');
				}
			});
		}
	}
	customElements.define('scroll-slider', scrollSlider);
}

class phoneInput extends HTMLElement {
	constructor() {
		super();
		this.selectors = {
			phoneInput: '[phone-input]',
			phoneInputCountryCode: '[code-input]',
			mergeInput: '[merge-input]',
		};
	}	

	connectedCallback() {
		this.phoneInput = this.querySelector(this.selectors.phoneInput);
		this.phoneInputCountryCode = this.querySelector(this.selectors.phoneInputCountryCode);
		this.mergeInput = this.querySelector(this.selectors.mergeInput);
		this.phoneCodeValue = this.phoneInputCountryCode.value || '';
		this.phoneValue = this.phoneInput.value || '';
		this.phoneInput.addEventListener('input', this.handlePhoneInput);
		this.phoneInputCountryCode.addEventListener('change', this.handleCountryCodeInput);
	}

	handlePhoneInput = (e) => {
		this.phoneValue = e.target.value;
		this.handleMerge();
	};

	handleCountryCodeInput = (e) => {
		this.phoneCodeValue = e.target.value;
		this.handleMerge();
	};

	handleMerge() {
		this.mergeInput.value = `${this.phoneCodeValue} ${this.phoneValue}`;
	}
}

if (!customElements.get('phone-input')) {
	customElements.define('phone-input', phoneInput);
}